import { defineMessages } from "react-intl";

const PREFIX = "AllNewsPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "All news",
  },
  addNew: {
    id: `${PREFIX}.addNew`,
    defaultMessage: "Add news",
  },
  confirmDialogContent: {
    id: `${PREFIX}.dialog.content`,
    defaultMessage: "Are you sure to delete this news?",
  },
  confirmDialogBtnYes: {
    id: `${PREFIX}.dialog.btn.yes`,
    defaultMessage: "Yes",
  },
  confirmDialogBtnNo: {
    id: `${PREFIX}.dialog.btn.no`,
    defaultMessage: "No",
  },
});
